import styled from 'styled-components';

export const ViewRoot = styled.div<{ $has100Height: boolean }>`
  display: flex;
  min-height: 100%;
  height: ${props => props.$has100Height && '100%'};
  //warning - must be minimum 100%
`;
